var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocEnergyOnDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16C6 10.4772 10.4772 6 16 6H44C49.5229 6 54 10.4772 54 16V44C54 49.5229 49.5228 54 44 54H16C10.4772 54 6 49.5228 6 44V16Z",
    fill: "#03A3E8",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 29.75C6 18.5541 6 12.9562 9.47811 9.47811C12.9562 6 18.5541 6 29.75 6C40.9459 6 46.5438 6 50.0219 9.47811C53.5 12.9562 53.5 18.5541 53.5 29.75C53.5 40.9459 53.5 46.5438 50.0219 50.0219C46.5438 53.5 40.9459 53.5 29.75 53.5C18.5541 53.5 12.9562 53.5 9.47811 50.0219C6 46.5438 6 40.9459 6 29.75Z",
    stroke: "#1EF5DF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8371 17.5827C31.8591 17.5871 31.8809 17.5916 31.9026 17.5959C37.4324 18.7134 41.5938 23.6074 41.5938 29.4752C41.5938 36.1657 36.1815 41.5938 29.5 41.5938C22.8185 41.5938 17.4062 36.1657 17.4062 29.4752C17.4062 26.0862 18.796 23.02 21.0334 20.8217C21.4666 20.3961 22.1627 20.4023 22.5882 20.8354C23.0138 21.2685 23.0076 21.9646 22.5745 22.3902C20.7411 24.1916 19.6051 26.6992 19.6051 29.4752C19.6051 34.956 24.0375 39.3949 29.5 39.3949C34.9625 39.3949 39.3949 34.956 39.3949 29.4752C39.3949 24.671 35.9879 20.6648 31.4671 19.7512C31.2318 19.7037 31.0511 19.6673 30.8953 19.6415C30.7778 19.6219 30.6941 19.6119 30.6331 19.6077C30.6027 19.8071 30.5994 20.1016 30.5994 20.6598V21.7618C30.5994 22.369 30.1072 22.8612 29.5 22.8612C28.8928 22.8612 28.4006 22.369 28.4006 21.7618V20.6598C28.4006 20.6372 28.4006 20.6146 28.4006 20.5919C28.4004 20.1169 28.4003 19.6372 28.4653 19.2387C28.5428 18.7644 28.7316 18.2646 29.2058 17.8756C29.6524 17.5092 30.1411 17.398 30.6205 17.4067C31.003 17.4137 31.4356 17.5013 31.8371 17.5827Z",
    fill: "#87FF0B",
    stroke: "#87FF0B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.4673 23.2207C24.7739 22.9711 25.2127 22.9678 25.5229 23.2128L31.62 28.0274C32.9128 29.0482 32.9195 30.9975 31.6336 32.027C30.3553 33.0504 28.4467 32.6416 27.7117 31.1738L24.2456 24.2528C24.0686 23.8993 24.1607 23.4703 24.4673 23.2207Z",
    fill: "#87FF0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocEnergyOnDate);
export default __webpack_public_path__ + "static/media/ic_soc_energy_on_date.6c0ee11ee1ca50b4569635f6f030342f.svg";
export { ForwardRef as ReactComponent };